import React, { useState, useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { currentDomain, currentPath } from '../Index';
import { usePromotionsData } from '../data/PromotionData';
import { useNavigate } from 'react-router-dom';
import useAppPromotionTheme from '../hooks/useAppPromotionTheme';
import PromotionSkeletonDetails from '../data/PromotionSkeletonDetails';

export default function PragmaticPlay({ isLightMode }) {
    const isAppPromo = useAppPromotionTheme(isLightMode);
    const { promotionsData, isPromotionDataReady } = usePromotionsData();
    const data = useMemo(
        () => promotionsData.find((promo) => promo.title === 'Play With Kevin'),
        [promotionsData]
    );
    const [isMobile, setIsMobile] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 841);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!isPromotionDataReady) return;

        if (!data) {
            navigate('/not-found', { replace: true });
        }
    }, [isPromotionDataReady, data, navigate]);

    if (!isPromotionDataReady) {
        return <PromotionSkeletonDetails />;
    }

    if (!data) {
        return null;
    }

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title> Play With Kevin </title>
                <link rel="icon" href="/images/fav.webp" sizes="32x32" />
                <meta name="description" content="ddd" />
                <link rel="canonical" href={`${currentDomain}${currentPath}`} />
            </Helmet>
            <div className="promotion-page-main all-page-main-container-min-height">
                <div className="promotion-page-container main-container-global-adjusted-padding">
                    <div className="promotion-tnc-page">
                        <div className="promotion-page-breadcrumb">
                            <a
                                href={
                                    isAppPromo
                                        ? '/promotion/'.replace(
                                              '/promotion',
                                              '/app-promotion'
                                          )
                                        : '/promotion/'
                                }
                            >
                                Promotions
                            </a>{' '}
                            / <span> {data.title} </span>
                        </div>
                        <div className="promotion-tnc-banner">
                            <img
                                src={isMobile ? data.imgSrc : data.bannerSrc}
                                alt={`FGH${data.title}`}
                            />
                            <div className="promotion-tnc-content">
                                <div className="promotion-tnc-info">
                                    <div
                                        className={`promotion-indication-message ${data.promotionMessage.class}`}
                                    >
                                        {data.promotionMessage.text}
                                    </div>
                                    <h1> Play With Kevin </h1>
                                    <h2> Prize Pool:₱11,832,000 </h2>
                                    <div className="promotion-tnc-period">
                                        <strong> Event Period </strong>
                                        <span>
                                            {' '}
                                            October 19 - November 8, 2026{' '}
                                        </span>
                                    </div>
                                </div>
                                <div className="promotion-tnc-mechanic-content">
                                    <strong> Terms and Conditions </strong>
                                    <ol>
                                        <li>
                                            Collect KEVIN will run from 19
                                            October 2026 16:00 to 2 November
                                            15:59 (GMT+8), with 90,000 prizes
                                            and a prize value of ₱11,832,000.
                                        </li>
                                        <li>
                                            To qualify for a random prize, you
                                            must place any real-money bet on any
                                            qualifying game and collect all [5]
                                            unique collectible text (namely [K],
                                            [E], [V], [I], and [N]).
                                        </li>
                                        <li>
                                            You will be eligible for a prize
                                            after all text are collected. If
                                            text are not completed, no prize,
                                            reward or benefit will be awarded.
                                        </li>
                                        <li>
                                            Word Drops are randomly triggered on
                                            any bet with only 1 ‘text’ awarded
                                            at a time. Once the first piece is
                                            collected, you will be eligible to
                                            collect the next pieces until all
                                            [5] text are obtained.
                                        </li>
                                        <li>
                                            After you have collected all [5]
                                            text, the screen will display a
                                            selection of chests. Pick a chest to
                                            open and reveal your random prize.
                                        </li>
                                        <li>
                                            Prizes are awarded as Free Chips
                                            with value of ₱11.6 each(or
                                            equivalent value) to be used only on
                                            Live Casino games – Mega Wheel,
                                            Amazing Baccarat, Gates of Olympus
                                            Roulette, Mega Roulette, Money Time,
                                            Sweet Bonanza Candyland, Color Game
                                            Bonanza and Seotda Baccarat. Free
                                            Chips could take up to 5 minutes to
                                            be issued to your account. Free chip
                                            prizes:
                                        </li>
                                        <ul>
                                            <li>
                                                10 chips with value of ₱11.6
                                                each (or equivalent value)
                                            </li>
                                            <li>
                                                30 chips with value of ₱11.6
                                                each (or equivalent value)
                                            </li>
                                        </ul>
                                        <li>
                                            Maximum winning for each Free Chips
                                            prizes are capped at
                                        </li>
                                        <ul>
                                            <li>₱1,160 for 10 chips</li>
                                            <li>₱3,480 for 30 chips.</li>
                                            <li>
                                                Any remaining Free Chips will be
                                                forfeited once the maximum win
                                                limit is reached.
                                            </li>
                                        </ul>
                                        <li>
                                            Players can choose to play Free
                                            Chips instantly or later and it will
                                            be valid for 2 days from the time of
                                            awarding, after which they will
                                            expire and will be forfeited.
                                        </li>
                                        <li>
                                            Qualified Games: All Pragmatic Play
                                            and PP POP slot games except Money
                                            Roll, Irish Charms, Diamonds are
                                            Forever 3 lines, Buffalo King,
                                            Buffalo King Megaways™, Buffalo King
                                            Untamed Megaways™, Buffalo King
                                            Megaways™ Dice, Table Games, Video
                                            Poker, and Scratch Cards.
                                        </li>
                                        <li>
                                            You can track your text collection
                                            in the promotional in-game
                                            interface. The promotional icon in
                                            the top-left corner displays how
                                            many of the [5] required text you
                                            have collected.
                                        </li>
                                        <li>
                                            Winnings from Free Chips are
                                            credited as cash with no wagering
                                            requirements.
                                        </li>
                                        <li>
                                            No minimum bet is required for this
                                            promotion.
                                        </li>
                                        <li>
                                            Pragmatic Play reserves the right to
                                            thoroughly review players activities
                                            to identify any potential abuse to
                                            ensure fair play within our Network
                                            Promotion. If any abuse is found,
                                            Pragmatic Play reserves the right to
                                            forfeit any amounts paid to winning
                                            players.
                                        </li>
                                        <li>
                                            Pragmatic Play reserves the right to
                                            amend, suspend or cancel the
                                            promotion at any time and without
                                            prior notice.
                                        </li>
                                    </ol>
                                    <div className="table-wrapper">
                                        <table
                                            className="promotion-tnc-table"
                                            style={{ minWidth: '0' }}
                                        >
                                            <thead>
                                                <th> Number of Prizes </th>
                                                <th> Prizes </th>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td> 84,000 </td>
                                                    <td> 10 x ₱11.6 chip </td>
                                                </tr>
                                                <tr>
                                                    <td> 6,000 </td>
                                                    <td> 30 x ₱11.6 chip </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="promotion-tnc-cta">
                                        <a
                                            className="promotion-cta-btn"
                                            href="https://pp88.asia/tl/play-with-kevin-slots-live-casino-network-promotion/"
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            View Full T&C
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
